<template>
  <div class="modal mymodal" :id="modalid" tabindex="-1" :aria-labelledby="modalid + 'Label'" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header" style='background: #9999FF;padding:2px'>
          <p class="modal-title">Change Password for USER {{userid}}</p>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <table>
          <tr><td>OLD PASSWD</td>
          <td><input id="myinp11" type="password" v-model="oldpasswd" ></td></tr>

          <tr><td>NEW PASSWD</td>
          <td><input id="myinp12" type="password" v-model="newpasswd1" ></td></tr>

          <tr><td>CONFIRM</td>
          <td><input id="myinp13" type="password" v-model="newpasswd2" ></td></tr>
          </table>

          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mymodal > div {
    position: absolute ;
    background-color: yellow;
}
.nomargin {
   margin-block-start: 0 ;
   margin-block-end : 0 ;
}
</style>

<script>
export default {
  name: 'ChgPasswd',
  props: {
    modalid: String,
    userid : String
  },
  methods: {
    reset() {
      this.oldpasswd = '' ;
      this.newpasswd1 = '' ;
      this.newpasswd2 = '' ;
    }
  },
  data() {
    return {
      oldpasswd: "", 
      newpasswd1: "", 
      newpasswd2: "" 
    }
  }
}
</script>
